export default {
  'pages.404.subTitle': 'দুঃখিত, আপনি যে পৃষ্ঠাটি দেখেছেন তা বিদ্যমান নেই।',
  'pages.404.buttonText': 'হোমে ফিরে যান',
};
